<template>
  <div id="page0">
    <div class="home-page" v-for="(item, index) in imageList" :key="index">
      <p class="home-png">
        <img :src="item.src1" />
      </p>
      <p class="home-png">
        <img :src="item.src2" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Company",
  data() {
    return {
      imageList: [
        {
          src1: require("../assets/company/company1-1.png"),
          src2: require("../assets/company/company1-2.jpg")
        },
        {
          src1: require("../assets/company/company2-1.png"),
          src2: require("../assets/company/company2-2.jpg")
        },
        {
          src1: require("../assets/company/company3-1.png"),
          src2: require("../assets/company/company3-2.jpg")
        },
        {
          src1: require("../assets/company/company4-1.png"),
          src2: require("../assets/company/company4-2.jpg")
        },
        {
          src1: require("../assets/company/company5-1.png"),
          src2: require("../assets/company/company5-2.jpg")
        },
        {
          src1: require("../assets/company/company6-1.png"),
          src2: require("../assets/company/company6-2.jpg")
        }
      ]
    };
  }
};
</script>

<style scoped>
#page0 {
  width: 100%;
  margin: 0;
}

/* .home-page:first-child {
  padding-top: 30px;
} */

@media (min-width: 1024px) {
  .home-page:first-child {
    margin-top: 75.2px;
    padding-top: 30px;
  }
}

@media (min-width: 767px) and (max-width: 1024px) {
  .home-page:first-child {
    margin-top: 49.2px;
    padding-top: 26px;
  }
}

@media (min-width: 480px) and (max-width: 767px) {
  .home-page:first-child {
    margin-top: 36.4px;
    padding-top: 16px;
  }
}

@media (max-width: 480px) {
  .home-page:first-child {
    margin-top: 29.65px;
    padding-top: 10px;
  }
}
</style>